import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { PaymentProviderQrDto } from '@model/MasterTransactionDto'

import { DepositProceedValues } from '../hooks/useDepositProceedRedirect'
import { ProceedModalContent } from './components/ProceedModalContent'

interface PaymentProviderModalProps {
  onProceed(): void
  values: DepositProceedValues
  qr?: PaymentProviderQrDto | null
  transactionId?: string
  onQrSuccess?(): void
  onQrDeclined?(): void
}

export const PaymentProviderProceedModal: BaseModalType<PaymentProviderModalProps> = ({
  onProceed,
  values,
  qr,
  transactionId,
  onQrSuccess,
  onQrDeclined,
  close,
}) => {
  const { t } = useTranslation()

  if (!values) return null

  return (
    <ProceedModalContent
      values={values}
      qr={qr}
      transactionId={transactionId}
      onProceed={onProceed}
      close={close}
      onQrSuccess={onQrSuccess}
      onQrDeclined={onQrDeclined}
    >
      <Modal.Body.Text>
        {t('You will be redirected to an external payment provider to complete your transaction')}
      </Modal.Body.Text>
    </ProceedModalContent>
  )
}
